import React,{useState,useEffect} from "react";
import './DropdownINV.css';

function DropdownINV(props) {
    const { nombreINV, colorINV, idINV, idCT } = props;

    //Deshabilitar el link si no hay pantalla de inversor
    const screen = JSON.parse(sessionStorage.getItem('ScreenConfiguration')).filter(screen => screen.Screen === "Inverter");
    const [hrefDisabled,setHrefDisabled] = useState(<></>);
   
    useEffect(() => {
        if(screen[0].Enabled === false){
            setHrefDisabled(
                <div className="div-inv-complete" style={{backgroundColor: colorINV}}>
                    <div className="inv-word">{ nombreINV }</div>
                </div>)
        }else{
            setHrefDisabled(
                <div className="div-inv-complete" style={{backgroundColor: colorINV}} onClick={() => { window.open("/#/inv/" + idCT + "/" + idINV, "_self")}}>
                    <div className="inv-word">{ nombreINV }</div>
                </div>)
        }
    },[]);

    return(
        <div>
            {hrefDisabled}
        </div>
    );
}

export default DropdownINV